import { DURING_STAY_SURVEY_SEND_ANSWER } from './../const';

function action(comment, vote, token, lang, context) {
  return { type: DURING_STAY_SURVEY_SEND_ANSWER, comment, vote, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/duringStaySurveySendAnswer.js